import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { FilterStore } from '../../shared/util-stores';
import { ChallengeRowInfo } from '../interfaces/challenges-list/ChallengeRowInfo';
import {
  ChallengeListFilters,
  ChallengeListFilterValues,
  ChallengeListSortField,
} from '../interfaces/challenges-list/ChallengeListFilters';
import { challengeService } from '../services/challengeService';
import { getEndOfDayInTz } from '../../shared/utils/timezoneUtils/getEndOfDayInTz';
import { getStartOfDayInTz } from '../../shared/utils/timezoneUtils/getStartOfDayInTz';
import { getUserSystemTimezone } from '../../shared/utils/timezoneUtils/getUserSystemTimezone';

class ChallengesListStore {
  challengesList: ChallengeRowInfo[] = [];
  filterMethods: FilterStore<ChallengeListFilterValues, ChallengeListSortField>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<
      ChallengeListFilterValues,
      ChallengeListSortField
    >(this.handleGetChallengesList);
  }

  setDefaultValues() {
    this.challengesList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetChallengesList(filterInfo: ChallengeListFilters) {
    const recalculatedFilterInfo = {
      ...filterInfo,
      filters: {
        ...filterInfo.filters,
        startDate: filterInfo.filters?.startDate
          ? getStartOfDayInTz(filterInfo.filters?.startDate, getUserSystemTimezone())
          : undefined,
        endDate: filterInfo.filters?.endDate
          ? getEndOfDayInTz(filterInfo.filters?.endDate, getUserSystemTimezone())
          : undefined,
      },
    };

    const data = await challengeService.getChallengesList(recalculatedFilterInfo);
    const { content } = data;

    this.setChallengesList(content);

    return data;
  }

  async getChallengesList() {
    return this.filterMethods.getData();
  }

  private setChallengesList(challengesList: ChallengeRowInfo[]) {
    this.challengesList = challengesList;
  }
}

const challengesListStore = new ChallengesListStore();

resetAllStore.addResetMethod(challengesListStore.setDefaultValues);

export { challengesListStore, ChallengesListStore };
